import { render } from "./ExpirationView.vue?vue&type=template&id=68800528"
import script from "./ExpirationView.vue?vue&type=script&lang=js"
export * from "./ExpirationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__